import React from 'react'

function CampaignGoals() {
  return (
    <div>
      
    </div>
  )
}

export default CampaignGoals